var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fullData)?_c('base-table',{attrs:{"data":_vm.fullData.data,"columns":_vm.fullData.columns,"actions":_vm.fullData.actions,"actionKey":_vm.fullData.actionKey},on:{"tbc":_vm.runClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return undefined}}],null,false,3646406178)},[_c('template',{slot:"columns"})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }